import request from '@/utils/request';
export function categoryRegion(data) {
  return request({
    url: '/count/order-consume-trend/category-region',
    method: 'post',
    data: data,
    hideLoading: true
  });
}

// 平台报表 - 订单消费统计 - 商城菜单统计 - 明细
export function orderCategoryDetail(params) {
  return request({
    url: '/count/order-consume-trend/category-detail',
    method: 'get',
    params: params
  });
}

// 平台报表 - 异常订单监控 - 商城菜单统计 - 明细
export function orderExceptionCategoryDetail(params) {
  return request({
    url: '/count/order-consume-exception/category-detail',
    method: 'get',
    params: params
  });
}

// 平台报表 - 平台利润测算 - 列表
export function orderProfitCalcList(params) {
  return request({
    url: '/plat/order-profit-calc/list',
    method: 'get',
    params: params
  });
}
// 平台报表 - 平台利润测算 - 导出
export function orderProfitCalcExport(params) {
  return request({
    url: '/plat/order-profit-calc/export',
    method: 'get',
    params: params
  });
}

// 平台报表 - 订单回款报表 - 列表
export function orderFinanceFlowList(params) {
  return request({
    url: '/plat/order-finance-flow/index',
    method: 'get',
    params: params
  });
}
// 平台报表 - 订单回款报表 - 导出
export function orderFinanceFlowExport(params) {
  return request({
    url: '/plat/order-finance-flow/export',
    method: 'get',
    params: params
  });
}

// 消费统计报表
export function getDataLlist(params) {
  return request({
    url: '/count/consume-stats/plat-count',
    method: 'get',
    params: params
  });
}
// 销售统计报表
export function getSaleStatsLlist(params) {
  return request({
    url: '/count/sale-stats/plat-count',
    method: 'get',
    params: params
  });
}

/**
 * 获取订单消费统计列表（平台报表）
 * @param {*} data
 * @returns
 */
export function getOrderList(params) {
  return request({
    url: '/count/order/index',
    method: 'get',
    params: params
  });
}
/**
 * 获取订单消费统计列表(数据中心)
 * @param {*} data
 * @returns
 */
export function getOrderList1(params) {
  return request({
    url: '/count/order/index-p',
    method: 'get',
    params: params
  });
}
/**
 * 获取渠道列表和id(数据中心)
 * @param {*} data
 * @returns
 */
export function getOrderChannelList(params) {
  return request({
    url: '/orders/channel/list',
    method: 'get',
    params: params
  });
}
/**
 * 导出订单消费统计列表 - 平台报表
 * @param {*} data
 * @returns
 */
export function exportOrderList(params) {
  return request({
    url: '/count/order/export',
    method: 'get',
    params: params
  });
}
/**
 * 导出订单消费统计列表-数据中心
 * @param {*} data
 * @returns
 */
export function exportOrderList1(params) {
  return request({
    url: '/count/order/data-center-export',
    method: 'get',
    params: params
  });
}
// 电商订单统计
export function getECommerceOrderStatisticsList(params) {
  return request({
    url: '/plat/shop-order/index',
    method: 'get',
    params: params
  });
}
/**
 * 礼包提成&兑换统计
 * @param {*} data
 * @returns
 */
export function getData(params) {
  return request({
    url: '/package/package/package-profit-count',
    method: 'get',
    params: params
  });
}
// 次卡消费统计
export function getSecondaryCardConsumptionStatisticsList(params) {
  return request({
    url: '/plat/order/count-times-order',
    method: 'get',
    params: params
  });
}
// 获取组织
export function getOrganize(params) {
  return request({
    url: 'orders/organize/tree-channel',
    method: 'get',
    params: params
  });
}
//  次卡导出
export function exportSecondaryCardConsumption(params) {
  return request({
    url: '/plat/order/export-count-times-order',
    method: 'get',
    params: params
  });
}
// 获取销售人员
export function getUserList(params) {
  return request({
    url: 'package/package-programme/cond-user-ids',
    method: 'get',
    params: params
  });
}
// 下载
export function exportSaleStats(params) {
  return request({
    url: '/count/sale-stats/download',
    method: 'get',
    params: params
  });
}

/**
 * 商品变价统计 - 获取变价列表
 * @param {*} params
 * @returns
 */
export function getChangePriceList(params) {
  return request({
    url: '/orders/change-price/get-list',
    method: 'get',
    params: params
  });
}

/**
 * 商品变价统计 - 获取报表数据
 * @param {*} params
 * @returns
 */
export function getChangePriceChart(params) {
  return request({
    url: '/orders/change-price/get-chart',
    method: 'get',
    params: params
  });
}

/**
 * 商品变价统计 - 获取变价幅度分布
 * @param {*} params
 * @returns
 */
export function getAmplitudeDistribution(params) {
  return request({
    url: '/orders/change-price/amplitude-distribution',
    method: 'get',
    params: params
  });
}
/**
 * 礼包利润分析
 * @param {*} params
 * @returns
 */
export function getPackageRateList(params) {
  return request({
    url: '/count/package-rate/index',
    method: 'get',
    params: params
  });
}
/**
 * 礼包利润分析-导出
 * @param {*} params
 * @returns
 */
export function exportPackage(params) {
  return request({
    url: '/count/package-rate/export',
    method: 'get',
    params: params
  });
}

// 礼包利润分析-更新
export function savePackageRate(data) {
  return request({
    url: '/count/package-rate/save',
    method: 'post',
    data: data
  });
}
/**
 * 礼包利润分析-客户列表
 * @param {*} params
 * @returns
 */
export function getCompanyList(params) {
  return request({
    url: '/orders/customer/by-channel',
    method: 'get',
    params: params
  });
}
// 查看详情
export function getChangeList(params) {
  return request({
    url: '/orders/change-price/get-change-list',
    method: 'get',
    params: params
  });
}
// 变价明细-导出
export function downloadChangeList(params) {
  return request({
    url: '/orders/change-price/download-change-list',
    method: 'get',
    params: params
  });
}
// 变价明细-移除
export function removeLog(params) {
  return request({
    url: '/orders/change-price/remove-log',
    method: 'get',
    params: params
  });
}
/**
 * 变价明细 - 获取商务负责人列表
 * @param {*} params
 * @returns
 */
export function getBusinessList(params) {
  return request({
    url: '/orders/change-price/get-business-list',
    method: 'get',
    params: params
  });
}
// 礼包缺货商品列表  已下单礼包 未下单礼包
export function getPackageOutGoodsIndexList(params) {
  return request({
    url: '/package/package-out-goods/index',
    method: 'get',
    params: params
  });
}
// 礼包缺货商品列表 搜索分类
export function getPackageOutGoodsSearchList(params) {
  return request({
    url: '/package/package-out-goods/get-search',
    method: 'get',
    params: params
  });
}
// 移除商品
export function removePackageOutGoods(data) {
  return request({
    url: '/package/package-out-goods/remove',
    method: 'post',
    data: data
  });
}
// 缺货礼包列表
export function getPackageOutGoodsList(params) {
  return request({
    url: '/package/package-out-goods/get-out-package',
    method: 'get',
    params: params
  });
}
export function getDetail(params) {
  return request({
    url: '/package/package-out-goods/goods-info',
    method: 'get',
    params: params
  });
}
// 礼包备选成本分析 - 列表
export function getStandbyStats(params) {
  return request({
    url: '/count/package/standby-stats',
    method: 'get',
    params: params
  });
}
// 礼包备选成本分析 - 导出
export function dataExport(params) {
  return request({
    url: '/count/package/standby-stats-export',
    method: 'get',
    params: params
  });
}
// 渠道经营统计
export function channelOperationList(params) {
  return request({
    url: '/user/channel-operation-report/list',
    method: 'get',
    params: params
  });
}
// 替换商品 原商品 替换商品列表
export function getReplaceGoodsList(params) {
  return request({
    url: '/package/package-out-goods/select-replace-goods-data',
    method: 'get',
    params: params
  });
}
// 待选商品
export function waitReplaceGoodsList(params) {
  return request({
    url: '/package/package-out-goods/replace-goods-data',
    method: 'get',
    params: params
  });
}
// 替换商品
export function saveReplaceGoods(data) {
  return request({
    url: '/package/package-out-goods/sub-select-replace-goods',
    method: 'post',
    data: data
  });
}
// 待选  分类列表
export function getCategoryGoodsList(params) {
  return request({
    url: '/package/category/replace-goods-data',
    method: 'get',
    params: params
  });
}
// 待选  供应商列表
export function getSupplierList(params) {
  return request({
    url: '/package/package-out-goods/supplier-list',
    method: 'get',
    params: params
  });
}
// 替换商品审核
export function replaceGoodsAudit(data) {
  return request({
    url: '/package/package-out-goods/audit-sub-select-replace-goods',
    method: 'post',
    data: data
  });
}

// 获取渠道列表
export function ordersChannelBusiness(data) {
  return request({
    url: '/orders/channel/business',
    method: 'post',
    data: data
  });
}
/**
 * 订单分类统计 - 列表数据
 * @param {*} params
 * @returns
 */
export function getOrderChannel(params) {
  return request({
    url: '/count/order-stats-channel-platform/index',
    method: 'get',
    params: params
  });
}

/**
 * 订单分类统计 - 导出列表数据
 * @param {*} params
 * @returns
 */
export function exportOrderChannel(params) {
  return request({
    url: '/count/order-stats-channel-platform/export',
    method: 'get',
    params: params
  });
}
/**
 * 平台报表 订单消费统计 & 异常订单监控 - 数据分析 - 下单城市统计
 * @param {*} params
 * @returns
 */
export function getOrderCityTrend(params, entry) {
  var url = '/count/order-consume-trend/order-city';
  if (entry === 'abnormalOrderMonitor') {
    url = '/count/order-consume-exception/order-city';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 平台报表 订单消费统计 & 异常订单监控 - 数据分析 - 下单城市统计 - 导出
 * @param {*} params
 * @returns
 */
export function getOrderCityExport(params, entry) {
  var url = '/count/order-consume-trend/order-city-export';
  if (entry === 'abnormalOrderMonitor') {
    url = '/count/order-consume-exception/order-city-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 平台报表 订单消费统计 & 异常订单监控 - 数据分析 - 下单省份统计
 * @param {*} params
 * @returns
 */
export function getOrderProvinceTrend(params, entry) {
  var url = '/count/order-consume-trend/order-province';
  if (entry === 'abnormalOrderMonitor') {
    url = '/count/order-consume-exception/order-province';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 平台报表 订单消费统计 & 异常订单监控 - 数据分析 - 下单省份统计 - 导出
 * @param {*} params
 * @returns
 */
export function getOrderProvinceExport(params, entry) {
  var url = '/count/order-consume-trend/order-province-export';
  if (entry === 'abnormalOrderMonitor') {
    url = '/count/order-consume-exception/order-province-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 平台报表 订单消费统计 & 异常订单监控 - 数据分析 - 商城菜单统计 - 导出
 * @param {*} params
 * @returns
 */
export function getCategoryCostExport(params, entry) {
  var url = '/count/order-consume-trend/category-export';
  if (entry === 'abnormalOrderMonitor') {
    url = '/count/order-consume-exception/category-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 平台报表 订单消费统计 & 异常订单监控 - 数据分析 - 商城菜单统计
 * @param {*} params
 * @returns
 */
export function getCategoryCostTrend(params, entry) {
  var url = '/count/order-consume-trend/category-cost';
  if (entry === 'abnormalOrderMonitor') {
    url = '/count/order-consume-exception/category-cost';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 订单消费趋势数据
 * @param {*} params
 * @returns
 */
export function getOrderTrend(params, entry) {
  var url = '/count/order-consume-trend/index';
  if (entry === 'abnormalOrderMonitor') {
    url = '/count/order-consume-exception/data-view';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 订单成本率趋势数据
 * @param {*} params
 * @returns
 */
export function getCostRateData(params, entry) {
  var url = '/count/order-consume-trend/cost';
  if (entry === 'abnormalOrderMonitor') {
    url = '/count/order-consume-exception/cost-trend';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 售后数据-满意度数据接口
 * @param {*} params
 * @returns
 */
export function exportOrderEvaluate(params) {
  var url = '/count/order-consume-trend/order-evaluate';
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 售后数据-评价明细数据接口
 * @param {*} params
 * @returns
 */
export function orderEvaluateDetail(params) {
  return request({
    url: '/count/order-consume-trend/order-evaluate-detail',
    method: 'get',
    params: params
  });
}
/**
 * 板块明细饼图数据
 * @param {*} params
 * @returns
 */
export function getPlateDetailPieChart(params) {
  return request({
    url: '/count/order-consume-trend/plate-detail-pie-chart',
    method: 'get',
    params: params
  });
}
/**
 * 订单成本率趋势 - 导出列表
 * @param {*} params
 * @returns
 */
export function exportCostRange(params) {
  var url = '/count/order-consume-trend/cost-export';
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 订单数据分析 - 运营日志列表
 * @param {*} params
 * @returns
 */
export function getOperationLog(params) {
  var url = '/count/order-consume-trend/operation-log';
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 订单数据分析 - 增加运营日志
 * @param {*} data
 * @returns
 */
export function addOperationLog(data) {
  var url = '/count/order-consume-trend/operation-log-save';
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 订单数据分析 - 获取操作日志列表
 * @param {*} data
 * @returns
 */
export function getConsumeOrderLog(data) {
  var url = '/count/order-consume-trend/order-log';
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 消费分类统计数据
 * @param {*} params
 * @returns
 */
export function getConsumeTrend(params, entry) {
  var url = '/count/order-consume-trend/pie-chart';
  if (entry === 'abnormalOrderMonitor') {
    url = '/count/order-consume-exception/pie-chart';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 订单消费趋势数据 - 导出列表数据
 * @param {*} params
 * @returns
 */
export function exportOrderTrend(params, entry) {
  var url = '/count/order-consume-trend/export';
  if (entry === 'abnormalOrderMonitor') {
    url = '/count/order-consume-exception/export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 礼包利润分析-查看明细列表
 * @param {*} params
 * @returns
 */
export function getDetailList(params) {
  return request({
    url: '/count/package/standby-stats-deliver-orders',
    method: 'get',
    params: params
  });
}
/**
 * 礼包备选成本分析-渠道搜索框数据
 * @param {*} params
 * @returns
 */
export function businessList(data) {
  return request({
    url: '/orders/channel/business-package-standby-stats',
    method: 'post',
    data: data
  });
}
// 平台中心导出消费明细
export function exportPayCard(params) {
  return request({
    url: '/count/order/order-pay-card-export',
    method: 'get',
    params: params
  });
}
// 客户消费统计 导出
export function exportCustomerOrder(params) {
  return request({
    url: '/plat/customer-order/export',
    method: 'get',
    params: params
  });
}
//客户消费统计 列表
export function getPlatCustomerOrderCount(params) {
  return request({
    url: '/plat/customer-order/count',
    method: 'get',
    params: params
  });
}
//客户消费统计 渠道列表
export function customerPlatChannelList(data) {
  return request({
    url: '/plat/channel/list',
    method: 'post',
    data: data
  });
}
//客户消费统计 客户列表
export function customerPlatList(params) {
  return request({
    url: '/plat/customer/plat-list',
    method: 'get',
    params: params
  });
}
//礼包利润分析客户搜索
export function getCompanyInfoPro(params) {
  return request({
    url: '/plat/customer/plat-list',
    method: 'get',
    params: params
  });
}
//预设卡类型留存率列表/获取所有卡类型
export function getAllCardTypeNew(params) {
  return request({
    url: '/plat/order-config/all-card-type',
    method: 'get',
    params: params
  });
}
//预设卡类型留存率列表-设置-留存率
export function changeRate(data) {
  return request({
    url: 'plat/order-config/up',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
export function getRenewalOrderList(params) {
  return request({
    url: '/count/order-consume-exception/renewal-list',
    method: 'get',
    params: params
  });
}
export function exportRenewalOrderList(params) {
  return request({
    url: '/count/order-consume-exception/renewal-export',
    method: 'get',
    params: params
  });
}

// 获取异常订单监控
export function getAbnormalOrderList(params) {
  return request({
    url: '/count/order/abnormal-consume-order',
    method: 'get',
    params: params
  });
}
/**
 * 异常订单监控 - 消费占比异常
 * @param {*} params
 * @returns
 */
export function getConsumeOccupancyList(params) {
  return request({
    url: '/count/order/consume-occupancy-order',
    method: 'get',
    params: params
  });
}
/**
 * 异常订单监控 - 消费占比异常 导出
 * @param {*} params
 * @returns
 */
export function exportOccupancyList(params) {
  return request({
    url: '/count/order/consume-occupancy-order-export',
    method: 'get',
    params: params
  });
}
// 导出异常订单监控
export function exportAbnormalOrderList(params) {
  return request({
    url: '/count/order/abnormal-consume-order-export',
    method: 'get',
    params: params
  });
}
/**
 * 异常订单监控 - 消费进度异常 - 导出
 * @param {*} params
 * @returns
 */
export function exportAbnormalOrderConsume(params) {
  return request({
    url: '/count/order-consume-exception/i-export',
    method: 'get',
    params: params
  });
}
/**
 * 多维度订单列表
 * @param {*} params
 * @returns
 */
export function getMonitorsList(params) {
  return request({
    url: '/count/order-consume-exception/monitors',
    method: 'get',
    params: params
  });
}
// 导出多维度订单列表
export function exportMonitorsList(params) {
  return request({
    url: '/count/order-consume-exception/monitors-export',
    method: 'get',
    params: params
  });
}
/**
 * 获取订单监控规则
 * @param {*} params
 * @returns
 */
export function getMonitorRule(params) {
  return request({
    url: '/count/order-consume-exception/monitor-rule',
    method: 'get',
    params: params
  });
}
/**
 * 创建 / 更新订单监控规则
 * @param {*} data
 * @returns
 */
export function setMonitorRule(data) {
  return request({
    url: '/count/order-consume-exception/monitor-rule-ops',
    method: 'post',
    data: data
  });
}
/**
 * 更改订单是否忽略属性
 * @param {*} data
 * @returns
 */
export function changeIgnore(data) {
  return request({
    url: '/count/order/ignore',
    method: 'post',
    data: data
  });
}
/**
 * 异常订单 - 导出订单消费明细
 * @param {*} params
 * @returns
 */
export function exportPayCardAbnormal(params) {
  return request({
    url: '/count/order-consume-exception/order-pay-card-export',
    method: 'get',
    params: params
  });
}
/**
 * 异常订单 - 标记
 * @param {*} data
 * @returns
 */
export function signOrderAbnormal(data) {
  return request({
    url: '/count/order-consume-exception/invalid-card-bin-order',
    method: 'post',
    data: data
  });
}
// 查看公司名称
export function getCustomerName(params) {
  return request({
    url: '/count/order/get-customer-name',
    method: 'get',
    params: params
  });
}
// 订单消费统计-修正采购成本
export function setOrderCost(data) {
  return request({
    url: '/count/order/set-order-cost',
    method: 'post',
    data: data
  });
}

/**
 * 订单消费统计 - 业务类型/卡类型汇总 数据分析
 * @param {*} data
 * @returns
 */
export function getTypePieChart(data, tag_type) {
  var url = {
    1: '/count/order-consume-trend/type-pie-chart',
    2: '/count/order-consume-trend/card-type-pie-chart'
  }[tag_type];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 订单消费统计 - 业务类型/卡类型汇总 数据分析 - 商城菜单统计
 * @param {*} data
 * @returns
 */
export function getCategoryCost(data, type) {
  var url = '/count/order-consume-trend/type-category-cost';
  if (type === 'pie') {
    url = '/count/order-consume-trend/type-category-cost-pie';
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 订单消费统计 - 业务类型 - 数据分析 - 商城菜单统计 - 导出
 * @param {*} data
 * @returns
 */
export function getTypeCategoryExport(params) {
  return request({
    url: '/count/order-consume-trend/type-category-export',
    method: 'get',
    params: params
  });
}
// 订单消费统计-组织机构-按组织统计
export function organizeCount(data) {
  return request({
    url: '/count/order/organize-count',
    method: 'post',
    data: data
  });
}

/**
 * 消费进度异常订单列表 列表
 * @param {*} params
 * @returns
 */
export function getOrderExceptionList(params) {
  return request({
    url: '/count/order-consume-exception/index',
    method: 'get',
    params: params
  });
}
/**
 * 预警开关
 * @param {*} data
 * @returns
 */
export function switchException(data) {
  return request({
    url: '/count/order-consume-exception/switch',
    method: 'post',
    data: data
  });
}
// 订单消费统计-标记
export function signOrder(data) {
  return request({
    url: '/count/order/invalid-card-bin-order',
    method: 'post',
    data: data
  });
}

/**
 * 消费进度异常订单列表 - 设置卡类型订单消费风控列表
 * @param {*} params
 * @returns
 */
export function getCardTypeList(params) {
  return request({
    url: '/count/order-consume-exception/card-type',
    method: 'get',
    params: params
  });
}

/**
 * 消费进度异常订单列表 - 设置卡类型订单消费风控列表 - 获取设置弹窗详情
 * @param {*} params
 * @returns
 */
export function getCardTypeDetail(params) {
  return request({
    url: '/count/order-consume-exception/card-type-detail',
    method: 'get',
    params: params
  });
}
/**
 * 设置卡类型订单消费风控规则 提交
 * @param {*} data
 * @returns
 */
export function setCardType(data) {
  return request({
    url: '/count/order-consume-exception/set-card-type',
    method: 'post',
    data: data
  });
}

// 平台报表-订单消费统计（组织机构）导出
export function exportOrder(params) {
  return request({
    url: '/count/order/organize-count-export',
    method: 'get',
    params: params
  });
}

/**
 * 获取标签管理列表
 * @param {*} params
 * @returns
 */
export function getTags(params) {
  return request({
    url: '/orders/tags/index',
    method: 'get',
    params: params
  });
}

/**
 * 添加标签
 * @param {*} data
 * @returns
 */
export function createTag(data) {
  return request({
    url: '/orders/tags/create',
    method: 'post',
    data: data
  });
}
// 编辑标签
export function updateTag(data) {
  return request({
    url: '/orders/tags/update',
    method: 'post',
    data: data
  });
}

/**
 * 删除标签
 * @param {*} params
 * @returns
 */
export function removeTag(params) {
  return request({
    url: '/orders/tags/delete',
    method: 'get',
    params: params
  });
}
// 获取订单统计售卡风险校验
export function getStatisticsAuditRisk(data) {
  return request({
    url: '/count/order/audit-risk',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 导出礼包备选成本分析：【备选发货单明细
export function exportDeliverOrders(params) {
  return request({
    url: '/count/package/standby-stats-deliver-orders-export',
    method: 'get',
    params: params
  });
}
// 获取业务场景列表
export function getBusinessSceneList(params) {
  return request({
    url: '/orders/tag-scenes/index',
    method: 'get',
    params: params
  });
}
// 添加业务场景
export function createBusinessScene(data) {
  return request({
    url: '/orders/tag-scenes/create',
    method: 'post',
    data: data
  });
}
// 编辑业务场景
export function updateBusinessScene(data) {
  return request({
    url: '/orders/tag-scenes/update',
    method: 'post',
    data: data
  });
}
// 删除业务场景
export function deleteBusinessScene(params) {
  return request({
    url: '/orders/tag-scenes/delete',
    method: 'get',
    params: params
  });
}
// 获取标签分类
export function getTagCategoryList(params) {
  return request({
    url: '/orders/tag-categories/index',
    method: 'get',
    params: params
  });
}
// 添加标签分类
export function createTagCategory(data) {
  return request({
    url: '/orders/tag-categories/create',
    method: 'post',
    data: data
  });
}
// 编辑标签分类
export function updateTagCategory(data) {
  return request({
    url: '/orders/tag-categories/update',
    method: 'post',
    data: data
  });
}
// 删除标签分类
export function deleteTagCategory(params) {
  return request({
    url: '/orders/tag-categories/delete',
    method: 'get',
    params: params
  });
}

// 交付订单数据 - 我的订单-我负责的订单
export function getMyOrders(params) {
  return request({
    url: '/orders/handover-order/my-orders',
    method: 'get',
    params: params
  });
}

// 交付订单数据 - 我的订单-我的异常订单
export function getMyAbnormalOrders(params) {
  return request({
    url: '/orders/handover-order/my-abnormal-orders',
    method: 'get',
    params: params
  });
}

// 交付订单数据 - 我的订单-风控督办订单
export function getMyRiskAssignOrders(params) {
  return request({
    url: '/orders/handover-order/my-risk-assign-orders',
    method: 'get',
    params: params
  });
}

// 交付订单数据 - 全部订单-交付订单
export function getAllOrders(params) {
  return request({
    url: '/orders/handover-order/all-orders',
    method: 'get',
    params: params
  });
}

// 交付订单数据 - 全部订单-异常订单
export function getAllAbnormalOrders(params) {
  return request({
    url: '/orders/handover-order/all-abnormal-orders',
    method: 'get',
    params: params
  });
}

// 交付订单数据 - 全部订单-风控督办订单
export function getAllRiskAssignOrders(params) {
  return request({
    url: '/orders/handover-order/all-risk-assign-orders',
    method: 'get',
    params: params
  });
}